import type { ReactElement } from 'react'

import { MonthlySalesPDF } from './Pdffiles'
import { MonthlySalesTable } from './Table'
import { SectionTitle } from '@/components/elements/SectionTitle'
import { Spacer } from '@/components/elements/Spacer'
import { TitleLayout } from '@/components/layout'
import { Head } from '@/components/layouts/Head'
import { Layout } from '@/components/layouts/Ir'

import type { AccordionProps } from '@/pages/ir/financial/monthly-sales'
import { MonthlySales } from '@/types/monthlySales'

type Props = {
  monthlySales: MonthlySales
  yearsPdf: Array<AccordionProps>
}
export const MonthlySalesPage = ({ monthlySales, yearsPdf }: Props) => {
  return (
    <Layout>
      <SectionTitle
        titleText="Monthly Sales Report"
        subTitleText="月次売上高速報"
        color="normal"
      />
      <Spacer h={{ sp: 70, pc: 120 }} />
      <MonthlySalesTable monthlySales={monthlySales} />
      <Spacer h={{ sp: 80, pc: 100 }} />
      <MonthlySalesPDF yearsPdf={yearsPdf} />
    </Layout>
  )
}

MonthlySalesPage.getLayout = (page: ReactElement) => {
  const breadCrumbs = [
    { name: 'ホーム', path: '/' },
    { name: '株主・投資家向け情報', path: '/ir' },
    { name: '業績・財務情報', path: '/ir/financial/' },
    { name: '月次売上高速報', path: '' },
  ]

  return (
    <>
      <Head
        title="月次売上高速報"
        description="トライアルホールディングスグループ営業店舗における月次売上高速報について掲載しています。"
        ogp={{ url: 'ir/financial/monthly-Sales' }}
      />
      <TitleLayout
        title="Investor Relations"
        subTitle="株主・投資家向け情報"
        breadCrumbs={breadCrumbs}
      >
        {page}
      </TitleLayout>
    </>
  )
}
